import React from "react";
import { IonSkeletonText } from "@ionic/react";

interface ChatHistorySkeletonProps {
  count?: number;
}

const ChatHistorySkeleton: React.FC<ChatHistorySkeletonProps> = ({ count = 6 }) => {
  return (
    <div className="p-[20px] space-y-4">
      {[...Array(count)].map((_, index) => (
        <div 
          key={index} 
          className={`flex justify-between items-center pb-4 ${
            index !== count - 1 ? 'border-b border-white/15' : ''
          }`}
        >
          <div className="flex-col space-y-[2px] w-full max-w-[80%]">
            <div>
              <IonSkeletonText 
                animated 
                style={{ 
                  width: '100%', 
                  height: '20px',
                  '--background': 'rgba(255, 255, 255, 0.1)',
                  '--border-radius': '4px'
                }}
              />
            </div>
            <div>
              <IonSkeletonText 
                animated 
                style={{ 
                  width: '60%', 
                  height: '14px',
                  '--background': 'rgba(255, 255, 255, 0.1)',
                  '--border-radius': '4px'
                }}
              />
            </div>
          </div>
          <div>
            <div className="w-[20px] h-[20px] rounded-full bg-white/10"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChatHistorySkeleton; 